module.exports = __webpack_public_path__ + "media/images/landing/bg/case-johany/youtube-e8837bd7dd1013aea209245473860178.png";